import http from '@/libs/AxiosPlugin'

const card = {
  list () {
    return http.get('/card/list')
  },

  get (id) {
    return http.post('/card/get', {id})
  },

  save (card) {
    return http.post('/card/save', card)
  },

  delete (id) {
    return http.post('/card/delete', {id})
  }
}

export default card



// WEBPACK FOOTER //
// ./src/api/card.js